<template>
    <div>
        <div class="fw-b fs20 flex j-c-c a-i-c h60px">
            <div @click="selectTab(0)" class="tab-box" :class="{ 'tab-val': tabVal === 0 }">
                发展历程
            </div>
            <span class="mh10">|</span>
            <div @click="selectTab(1)" class="tab-box" :class="{ 'tab-val': tabVal === 1 }">
                虹星荣耀
            </div>
        </div>
        <div class="p20 h440px history-title" v-show="tabVal === 0">
            <div class="h350px flex pl200 j-c-c flex-column">
                <p class="w-total fs14 lh28 c-white" v-for="(t, x) in historyText" :key="x + 'hisTxt'">{{ t }}</p>
            </div>
            <swiper class="w320px mh-a" ref="historySwiper" @slideChangeTransitionStart="histortChange"
                :options="historyOptions" key="history">
                <swiper-slide v-for="(item, index) in list" :key="`${index}_history`" class="gb-trans ">
                    <h1 class="m-history text-center c-white transtion lh40 c-pointer"
                        :class="{ fs40: index === historyIndex }" @click="hisClick(index)">
                        {{ item.date }}
                    </h1>
                </swiper-slide>
            </swiper>
        </div>
        <!-- 虹星荣耀 -->
        <div class="p10 text-center fs16" v-show="tabVal === 1">
            <swiper ref="mySwiper" @slideChangeTransitionEnd="slideChange" :lazy="true" :options="swiperOptions"
                key="glory">
                <swiper-slide v-for="(item, index) in slideList" :key="`${index}_swiper`" :lazy="true">
                    <div class="p10">
                        <img :src="`/static/img/reward/${item.id}.jpg`" loading="lazy" class="swiper-lazy" />
                    </div>
                    <h4>{{ item.label }}</h4>
                </swiper-slide>
            </swiper>

            <div class="flex mt10 j-c-c pc-hidden">
                <ul class="w200px h40px flex c-white a-i-c j-s-b fs24 text-center operate-box">
                    <li @click="nextSwiper('prev')">
                        <i class="el-icon-arrow-left"></i>
                    </li>
                    <div class="c-g-d">
                        <span class="fs20 c-black">{{ swiperIndex / 4 }}</span>
                        <span class="fs18">/</span>
                        <span class="fs16">{{ slideList.length / 4 }}</span>
                    </div>
                    <li @click="nextSwiper('next')">
                        <i class="el-icon-arrow-right"></i>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import historyList from "@/assets/history/history";
import historyListEn from "@/assets/history/history-en";

import gloryList from "@/assets/glory/glory";
import gloryListEn from "@/assets/glory/glory-en";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
    name: "IristarHistory",
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            historyText: [],
            historyIndex: 1,
            swiperIndex: 4,
            tabVal: 0,
            swiperOptions: {
                autoHeight: true,
                slidesPerView: 4,
                autoplay: true,
                loop: true,
                slidesPerGroup: 4,
            },
            historyOptions: {
                autoplay: false,
                autoHeight: true,
                slidesPerView: 3,
            },
        };
    },
    created() {
        let innerW = window.innerWidth;
        let size = innerW > 768 ? 4 : 1
        this.swiperOptions.slidesPerView = size;
    },
    computed: {
        list() {
            return this.$store.state.language === "zh"
                ? historyList
                : historyListEn;
        },
        slideList() {
            let arr = this.$store.state.language === "zh"
                ? gloryList
                : gloryListEn
            return arr;
        },
        swiperObj() {
            return this.$refs.mySwiper.$swiper;
        },
        swiperObjHis() {
            return this.$refs.historySwiper.$swiper;
        },
    },
    mounted() {
        this.swiperObjHis.slideTo(11, 3000);
    },
    methods: {
        selectTab(x) {
            this.tabVal = x;
        },
        nextSwiper(n) {
            n === "next"
                ? this.swiperObj.slideNext()
                : this.swiperObj.slidePrev();
        },
        slideChange() {
            this.swiperIndex =
                this.swiperObj.realIndex === 0 ? 20 : this.swiperObj.realIndex;
        },
        histortChange() {
            let x = this.swiperObjHis.realIndex + 1;
            this.historyIndex = x;
            this.historyText = this.list[x].text;
        },
        hisClick(index) {
            if (index === 12) {
                return false;
            }
            this.swiperObjHis.slideTo(index - 1);
        },
    },
};
</script>

<style lang="less" scoped>
.tab-val {
    color: rgb(20, 6, 6);
    font-size: 24px;
}

.swiper-slide {
    background-color: #fff;

    h4 {
        margin: 0 24px;
        color: #201836;
        font-weight: 400;
        font-size: 14px;
        border-top: 2px solid #dbdbe4;
        line-height: 40px;
    }
}

.tab-box {
    transition: all 0.4s;
    cursor: pointer;
}

.swiper-pagination {
    bottom: 0;
}
</style>